'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonItemContainer = exports.CommonItemContainerNotConnected = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _galleryActions = require('../../actions/galleryActions.js');

var _itemViewActions = require('../../actions/itemViewActions.js');

var _reactRedux = require('react-redux');

var _itemActions = require('@wix/photography-client-lib/dist/src/item/itemActions');

var _windowWrapper = require('@wix/photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonItemContainerNotConnected = exports.CommonItemContainerNotConnected = function CommonItemContainerNotConnected(ComposedComponent) {
  var InnerComponent = function (_React$Component) {
    (0, _inherits3.default)(InnerComponent, _React$Component);

    function InnerComponent(props, context) {
      (0, _classCallCheck3.default)(this, InnerComponent);

      var _this = (0, _possibleConstructorReturn3.default)(this, (InnerComponent.__proto__ || (0, _getPrototypeOf2.default)(InnerComponent)).call(this, props, context));

      _this.updateLoveCount = _this.updateLoveCount.bind(_this);

      _this.state = {
        isLoved: _itemActions.itemActions.isLoved(props.photoId),
        loveCount: 0
      };
      return _this;
    }

    (0, _createClass3.default)(InnerComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        _windowWrapper2.default.addEventListener('love_count_fetched', this.updateLoveCount);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _windowWrapper2.default.removeEventListener('love_count_fetched', this.updateLoveCount);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var photoId = nextProps.photoId;

        this.setState({
          isLoved: _itemActions.itemActions.isLoved(photoId),
          loveCount: _itemActions.itemActions.getLoveCount(photoId)
        });
      }
    }, {
      key: 'updateLoveCount',
      value: function updateLoveCount() {
        this.setState({
          loveCount: _itemActions.itemActions.getLoveCount(this.props.photoId)
        });
      }
    }, {
      key: 'toggleLove',
      value: function toggleLove() {
        _itemActions.itemActions.postLoveActivity(this.props);
        _itemActions.itemActions.toggleLove(this.props.photoId, 'gallery');
        this.setState({
          isLoved: !this.state.isLoved
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var photoId = this.props.photoId;
        var _state = this.state,
            isLoved = _state.isLoved,
            loveCount = _state.loveCount;

        return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, {
          love: {
            isLoved: isLoved,
            count: loveCount + (isLoved ? 1 : 0),
            toggleLove: this.toggleLove.bind(this)
          }
        }));
      }
    }]);
    return InnerComponent;
  }(_react2.default.Component);

  return InnerComponent;
};

var CommonItemContainer = exports.CommonItemContainer = function CommonItemContainer(ComposedComponent) {
  var commonItemContainerNotConnected = CommonItemContainerNotConnected(ComposedComponent);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var galleryState = state.gallery || {};
    return {
      playing: galleryState.videoIndexPlay === ownProps.idx,
      documentHeight: galleryState.documentHeight,
      previewHover: galleryState.previewHover
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, { videoEnded: _galleryActions.videoEnded, videoAdded: _galleryActions.videoAdded, videoRemoved: _galleryActions.videoRemoved, playVideo: _itemViewActions.playVideo, pauseVideo: _itemViewActions.pauseVideo })(commonItemContainerNotConnected);
};